module.exports = __webpack_public_path__ + "img/pete.a751f1a8.png";